import * as React from "react";
import { FaPlus } from "react-icons/fa";

import {
  DraggableContainer,
  DraggablePlaceholder,
} from "../../../../pages/CourseAuthor/PreviewTab/DraggableContainer.styles";
import { CourseComponentTag, CourseUnitView, ICourseEditOperations, IFullCourse } from "../../../types";
import UnitDropTarget from "./UnitDropTarget";
import { AddUnitButton, ListItem, ListItemContainer, ListItemTitle } from "./UnitList.styles";
import { DropZone } from "../../../../../context/UseDragAndDrop";

export interface IAddUnitButtonWithDropTargetProps {
  alternateColor: boolean;
  course: IFullCourse;
  courseId: string;
  dropPosition: number;
  editOperations: ICourseEditOperations;
  unitPath?: CourseUnitView[];
}

const AddUnitButtonWithDropTarget: React.SFC<IAddUnitButtonWithDropTargetProps> = props => (
  <DraggableContainer>
    <UnitDropTarget
      editOperations={props.editOperations}
      dropPosition={props.dropPosition}
      path={props.unitPath || []}
      type={null}
      alternateColor={props.alternateColor}
    />
    <DraggablePlaceholder height={4} />
    <DropZone
      dropPosition={props.dropPosition}
      dropZoneType={"unit"}
      newInstructionType={null}
      editOperations={props.editOperations}
      path={props.unitPath || []}
    >
      <ListItem alternateColor={props.alternateColor}>
        <ListItemContainer>
          <ListItemTitle>
            <AddUnitButton
              onClick={props.editOperations.createComponent(props.unitPath || [], CourseComponentTag.Unit)}
            >
              <FaPlus color={"inherit"} /> Add Unit
            </AddUnitButton>
          </ListItemTitle>
        </ListItemContainer>
      </ListItem>
    </DropZone>
  </DraggableContainer>
);

export default AddUnitButtonWithDropTarget;
